/* eslint-disable import/prefer-default-export */

const isObject = value => value !== null && typeof value === 'object' && !Array.isArray(value);

const asObject = value => (isObject(value) ? value : {});

const getValue = (source, keys) => {
  for (const key of keys) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      return source[key];
    }
  }

  return undefined;
};

const normalizeOneShell = value => {
  if (!Array.isArray(value)) {
    return value;
  }

  return value.map(item => {
    const source = asObject(item);

    return {
      ...source,
      TIPO: getValue(source, ['type', 'TIPO']),
      NOME: getValue(source, ['name', 'NOME']),
      LIGHT: getValue(source, ['light', 'LIGHT']),
      DARK: getValue(source, ['dark', 'DARK'])
    };
  });
};

const normalizeColors = value => {
  const source = asObject(value);
  const oneShell = getValue(source, ['one_shell', 'ONESHELL']);

  return {
    ...source,
    CORBASECLIENTE: getValue(source, ['base_client', 'CORBASECLIENTE']),
    CORSECUNDARIACLIENTE: getValue(source, ['secondary_client', 'CORSECUNDARIACLIENTE']),
    ONESHELL: normalizeOneShell(oneShell)
  };
};

const normalizeImages = value => {
  const source = asObject(value);

  return {
    ...source,
    LOGO: getValue(source, ['logo', 'LOGO']),
    LOGO_RELATORIO: getValue(source, ['report_logo', 'LOGO_RELATORIO']),
    FAVICON: getValue(source, ['favicon', 'FAVICON']),
    LOGIN_BACKGROUND: getValue(source, ['login_background', 'LOGIN_BACKGROUND']),
    LOGO_ONESHELL: getValue(source, ['one_shell_logo', 'LOGO_ONESHELL'])
  };
};

const normalizeDocuments = value => {
  const source = asObject(value);

  return {
    ...source,
    termos_e_condicoes_de_uso: getValue(source, [
      'terms_and_conditions_of_use',
      'termos_e_condicoes_de_uso'
    ]),
    aviso_de_privacidade: getValue(source, ['privacy_notice', 'aviso_de_privacidade'])
  };
};

const normalizeServices = value => {
  const source = asObject(value);

  return {
    ...source,
    HUBSPOT_CHAT: getValue(source, ['hubspot_chat', 'HUBSPOT_CHAT']),
    HUBSPOT_NPS: getValue(source, ['hubspot_nps', 'HUBSPOT_NPS'])
  };
};

const normalizeSystem = value => {
  const source = asObject(value);

  return {
    ...source,
    tenant_name: getValue(source, ['tenant_name']),
    pasta_bucket: getValue(source, ['bucket_path', 'pasta_bucket']),
    dominio: getValue(source, ['domain', 'dominio']),
    site_institucional: getValue(source, ['institutional_site', 'site_institucional']),
    email_suporte: getValue(source, ['support_email', 'email_suporte']),
    email_comercial: getValue(source, ['commercial_email', 'email_comercial']),
    dominio_padrao_email: getValue(source, ['default_email_domain', 'dominio_padrao_email']),
    dominio_padrao_email_suporte: getValue(source, [
      'default_support_email_domain',
      'dominio_padrao_email_suporte'
    ])
  };
};

export const normalizarEscopoAmbiente = payload => {
  const envelope = asObject(payload);
  const scope = isObject(envelope.data) ? envelope.data : envelope;

  return {
    ...scope,
    cores: normalizeColors(getValue(scope, ['colors', 'cores'])),
    imagens: normalizeImages(getValue(scope, ['images', 'imagens'])),
    documentos: normalizeDocuments(getValue(scope, ['documents', 'documentos'])),
    servicos: normalizeServices(getValue(scope, ['services', 'servicos'])),
    sistema: normalizeSystem(getValue(scope, ['system', 'sistema']))
  };
};
